import { isRecord } from 'utils/objectUtils';

const TARIFF_EDITOR_ONLY_FIELDS = new Set([
  '_rowID',
  'isAnesthesiaUnitsManual',
  'isDirty',
  'originalRate',
  'province',
  'serviceEndOverridden',
  'serviceStartOverridden',
  'total',
]);

const normalizeTariffForRuleEvaluation = (
  tariff: unknown,
  claimData: Record<string, unknown>
): unknown => {
  if (!isRecord(tariff)) return tariff;

  const normalized = Object.fromEntries(
    Object.entries(tariff).filter(
      ([field]) => !TARIFF_EDITOR_ONLY_FIELDS.has(field)
    )
  );

  normalized.anesthesiaUnits = Number(tariff.anesthesiaUnits ?? 0);
  normalized.icd9 = tariff.icd9 ?? '';
  normalized.incision = tariff.incision || null;
  normalized.percentage = Number(tariff.percentage ?? 100);

  if (
    tariff.serviceStart == null ||
    tariff.serviceStart === claimData.serviceStart
  ) {
    normalized.serviceStart = null;
  }
  if (tariff.serviceEnd == null || tariff.serviceEnd === claimData.serviceEnd) {
    normalized.serviceEnd = null;
  }

  return normalized;
};

export const normalizeClaimRuleEvaluationData = <
  ClaimData extends Record<string, unknown>
>(
  claimData: ClaimData
): ClaimData => ({
  ...claimData,
  ...(Array.isArray(claimData.tariffs) && {
    tariffs: claimData.tariffs.map((tariff) =>
      normalizeTariffForRuleEvaluation(tariff, claimData)
    ),
  }),
});
